import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { parse as parseQuery } from 'hub-http/helpers/params';
import H1 from 'UIComponents/elements/headings/H1';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import LoginLoading from '../shared/LoginLoading';
import { useOneTimePassword } from './useOneTimePassword';

const OneTimePasswordComponent = props => {
  const {
    search
  } = props.location;
  const query = parseQuery(search.substr(1));
  const {
    otp,
    otpId,
    userId,
    next,
    template
  } = query;
  const {
    isLoading,
    responseLanguageKey,
    onLoad,
    resendHandler,
    isExpired,
    isError,
    templateLanguageKey
  } = useOneTimePassword({
    otp,
    otpId,
    next,
    template,
    userId
  });
  useEffect(() => {
    onLoad(); // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: "vertical-centered",
    children: isLoading ? /*#__PURE__*/_jsx(LoginLoading, {}) : /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "column",
      children: [isError && /*#__PURE__*/_jsx(UIIllustration, {
        name: "empty-state-charts",
        width: "50%"
      }), /*#__PURE__*/_jsx(H1, {
        children: responseLanguageKey && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `login.otp.${templateLanguageKey}.${responseLanguageKey}.title`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: responseLanguageKey && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `login.otp.${templateLanguageKey}.${responseLanguageKey}.body`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: isExpired && /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          className: "m-top-10",
          onClick: resendHandler,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `login.otp.${templateLanguageKey}.expired.button`
          })
        })
      })]
    })
  });
};

export default OneTimePasswordComponent;